<template>
<div class="groupList-list" v-if="finalDatas.items&&finalDatas.items.length>0&&canShow">
    <div class="title">
        <div class="tl" :style="titFontSize">{{finalDatas.goodstitle}}</div>
        <div class="more" @click="goGroupList">更多<i class="iconfont icongengduo1"></i></div>
    </div>
    <div class="goods-list-box" scroll-x="true" :class="finalDatas.layout">
        <div class="goods-list-container">
            <div class="box" v-for="(item,i) in finalDatas.items" :key="i" @click="goGroup(item)" :style="goodsStyle">
                <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
                    <img class="img" :src="item.goodsLogo+thumbSuffix" :style="imgStyle" />

                </div>
                <div class="goods-content">
                    <div class="goods-name">{{item.goodsName}}</div>

                    <div class="price-box" :style="priceColor">
                        <div class="price">
                            <span class="cur-price">
                                <i>￥</i>
                                <b :style="priceSize">{{item.groupPrice}} </b>
                                <i>团购价</i>
                            </span>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
</template>

<script>
// 抢购
import price from '@/components/price';
import {
    setStorage,
    getStorage
} from "@/utils/wxuser";
import api from "@/utils/api";
var config = {};

export default {
    props: {
        datas: Object,
        showHeader: {
            type: Boolean,
            default: () => true
        },
        templateId: String,
    },
    data() {
        return {
            timer: null,
            creditName: getStorage('creditName') || '积分',
            currentTime: '',
            code: "",
            finalDatas: {},
            isSquarePic: getStorage('isSquarePic') || 'F',
            canShow: false
        };
    },
    components: {
        price
    },
    computed: {

        goodsStyle() {
            var style = ''

            if (this.finalDatas.backgroundColor) {
                style += `background:${this.finalDatas.backgroundColor};`
            }
            return style
        },
        priceColor() {
            return `color:${this.finalDatas.priceColor}`
        },
        titFontSize() {

            var titFontSize = `font-size:${this.finalDatas.titFontSize};`
            if (this.finalDatas.titColor) {
                titFontSize += `color:${this.finalDatas.titColor};`
            }

            return titFontSize
        },
        thumbSuffix() {
            var thumbSuffix = "";
            if (this.isSquarePic == 'T') {
                thumbSuffix =
                    "?imageView2/1/w/690/h/690/format/webp&x-oss-process=image/resize,m_fill,w_694,h_694";
            } else {
                if (this.finalDatas.layout == "pic") {
                    thumbSuffix =
                        "?imageView2/1/w/690/h/460/format/webp&x-oss-process=image/resize,m_fill,w_694,h_460";
                } else {
                    thumbSuffix =
                        "?imageView2/1/w/336/h/224/format/webp&x-oss-process=image/resize,m_fill,w_336,h_224";
                }
            }

            return thumbSuffix;
        },
    },

    methods: {
        goGroup(goods) {
            this.$router.push({
                path: "/goodsDetail",
                query: {
                    id: goods.id,
                    productType: "group",
                },
            });
        },
        goGroupList() {

            this.$router.push({
                path: "/groupBookList",
            });
        },
        initeData() {

            this.finalDatas = JSON.parse(JSON.stringify(this.datas));
            console.log( this.finalDatas )
            var items = []
            api.findShopGroupList({
                    hotelGroupCode: config.hotelGroupCode,
                    hotelCode: config.hotelCode,
                    shopChannel: "group",
                    equipment: "desktop",
                    firstResult: 0,
                    pageSize: 100,
                    channel: config.channel,
                    appid: config.appid,
                })
                .then((res) => {
                    this.canShow = true
                    if (res.result == 1) {
                        var groupList = res.retVal.datas;
                        groupList.forEach(utem => {
                            this.finalDatas.items.forEach(goods => {
        
                                if (utem.id == goods.id) {
                                    
                                    items.push(utem)

                                }
                            })

                        })

                    }
                    this.finalDatas.items = items

                });

        },
        goFlashGoods(item) {
            if (!item.url) {
                this.$router.push({
                    path: '/goodsDetail',
                    query: {
                        flashTimeSlotRelitionId: item.relationId,
                        id: item.id,
                        productType: 'flash'
                    }
                });
            } else {
                window.location.href = `${window.location.origin}${item.url}`;
            }
        },

    },
    created() {
        config = getStorage("config");
    },
    mounted() {
        this.initeData()

    }
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.groupList-list {
    margin-top: 0.4rem;

    .title {
        display: flex;
        position: relative;
        height: 1.2rem;
        align-items: center;

        .tl {
            padding-left: 0.533333rem;
            font-size: 18px;
            color: #1d1e2c;
            font-weight: bold;
        }

        .more {
            font-size: 12px;
            color: #666666;
            display: flex;
            position: relative;
            height: 1.2rem;
            align-items: center;
            position: absolute;
            bottom: 0;
            right: 0.533333rem;

            i {
                font-size: 12px;
                color: #666666;
            }
        }

        // .arrow::after {
        //   width: 0.16rem;
        //   height: 0.16rem;
        //   margin-top: -2px;
        // }
    }

    .goods-list-box {
        margin-top: -0.266667rem;
        padding: 0 0.133333rem 0;

        .box-container {
            padding-bottom: 0.74rem;
            display: inline-block;
            vertical-align: top;
        }

        .box {
            position: relative;
            width: 4.586667rem;
            padding: 0 0 0.266667rem 0;
            background: #fff;

            border-radius: 0.213333rem;
            margin: 0.133333rem;
            box-sizing: border-box;

            .img-box {
                width: 100%;
                overflow: hidden;
                height: 3.05rem;
                position: relative;
                box-sizing: border-box;

                &.img-box-square {
                    height: 4.586667rem;
                }

                .img {
                    width: 100%;
                    height: 100%;
    
                    border-radius: 0.213333rem 0.213333rem 0 0;
                }

                .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }

                .label {
                    position: absolute;
                    top: 0.053333rem;
                    left: 0.053333rem;
                    color: #fff;
                    height: 0.64rem;
                    font-size: 12px;
                    color: #ffffff;
                    padding: 0 0.266667rem;
                    line-height: 0.64rem;
                    text-align: center;
                    z-index: 2;

                    &::after {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: -1;
                        width: 100%;
                        height: 100%;
                        background: @color-theme;
                        opacity: 0.6;
                        border-radius: 0.213333rem 0.213333rem 0.213333rem 0px;
                    }
                }
            }

            .goods-content {
                padding: 0 0.266667rem;

                .goods-name {
                    font-family: PingFangSC-Regular;
                    margin-top: 0.133333rem;
                    font-size: 14px;
                    line-height: 0.533333rem;
                    height: 1.066667rem;
                    color: #333333;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    white-space: normal;
                }

                .price-box {
                    display: flex;
                    justify-content: flex-start;
                    color: #e55141;

                    .price {
                        font-size: 12px;
                        display: inline-block;
                        align-items: center;

                        margin-top: 0.1333rem;
                        min-height: 0.6665rem;

                        .cur-price {
                            display: inline-block;
                            // font-family: TimesNewRomanPS-ItalicMT;
                            font-family: @price-font-family;
                        }

                        span {
                            display: inline-block;

                            i {
                                display: inline-block;
                                font-family: @price-font-family;
                                text-decoration: none;
                            }

                            b {
                                display: inline-block;
                                text-decoration: none;
                                // font-family: TimesNewRomanPS-BoldItalicMT;
                                font-family: @price-font-family;
                                font-size: 18px;
                            }
                        }

                        span.proposedPrice {
                            line-height: 16px;
                            text-decoration: line-through;
                            color: #999999;
                            font-size: 12px;
                            // font-style: italic;
                        }

                        .credit {
                            display: inline-block;
                            font-style: normal;

                            font-weight: bold;
                            font-size: 10px;
                            line-height: 16px;

                            em,
                            b {
                                display: inline-block;
                            }

                            span {
                                // font-family: TimesNewRomanPS-BoldItalicMT;
                                font-size: 14px;
                                display: inline-block;
                                font-family: @price-font-family;
                            }
                        }

                        .free {
                            b {
                                font-size: 18px;
                            }
                        }
                    }
                }
            }
        }

        &.grid {
            .goods-list-container {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
            }
        }

        &.mult {
            width: 100%;
            white-space: nowrap;
            display: flex;
            overflow-y: hidden;
            overflow-x: scroll;

            .goods-list-container {
                display: flex;

                .box {
                    width: 4rem;
                    margin-right: 0.266667rem;

                    .img-box {
                        height: 2.666667rem;

                        &.img-box-square {
                            height: 4rem;
                        }
                    }
                }
            }
        }

        &.pic {
            padding: 0 0.133333rem 0.74rem;
            box-sizing: border-box;

            .box {
                width: 100%;
                margin: 0.133333rem 0;
                border-radius: 0;
                border-top-left-radius: 0.533333rem;

                .img-box {
                    padding: 0.106667rem;
                    height: 4rem;

                    .bg {
                        display: none;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                        border-top-left-radius: 0.533333rem;
                        border-bottom-right-radius: 0.533333rem;
                    }

                    .label {
                        top: 0.106667rem;
                        left: 0.106667rem;
                        border-top-left-radius: 0.533333rem;
                    }
                }

                .goods-content {
                    .goods-name {
                        font-size: 18px;
                        color: #333333;
                        line-height: 0.666667rem;
                        height: 0.666667rem;
                        -webkit-line-clamp: 1;
                    }

                    .price {
                        justify-content: flex-start;
                    }
                }
            }
        }

        &.card {
            padding: 0 0.133333rem 0.74rem;
            box-sizing: border-box;

            .box {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin: 0.133333rem 0;
                border-radius: 0;
                padding: 0;
                border-top-left-radius: 0.533333rem;

                .img-box {
                    width: 4.346667rem;
                    height: 3.626667rem;

                    .bg {
                        display: none;
                    }

                    .bg2 {
                        display: block;
                    }
                }
            }

            .goods-content {
                flex: 1;
                text-align: left;

                .goods-name {
                    font-size: 14px;
                    color: #333333;
                    -webkit-line-clamp: 4;
                    line-height: 0.533333rem;
                    height: 2.133333rem;
                }

                .price {
                    justify-content: flex-start;
                }
            }
        }

        .time {
            background: #ffffff;
            width: 100%;
            height: 0.48rem;
            display: flex;
            align-items: center;
            border: 1px solid #e55141;
            border-radius: 4px;
            position: absolute;
            bottom: -0.74rem;

            &.grey {
                border: 1px solid #999;

                .lable {
                    background: #999;
                }

                .val {
                    color: #999;
                }
            }

            .lable {
                height: 100%;
                display: flex;
                align-items: center;
                background: #e55141;
                padding: 0 0.186667rem;
                color: #fff;
            }

            .val {
                flex: 1;
                color: #e55141;
                text-align: center;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/groupList.vue